export default "__VITE_ASSET___sgxf1o9__"